import React, { useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

const LeadSignup = () => {
    const [form, setForm] = useState({ name: "", whatsapp: "", email: "" });
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/leads", form);
            setDone(true);
            toast.success("Obrigado! Em breve você receberá nossas novidades.");
            setForm({ name: "", whatsapp: "", email: "" });
        } catch {
            toast.error("Não foi possível cadastrar. Tente novamente.");
        }
        setLoading(false);
    };

    return (
        <section data-testid="lead-signup-section" className="bg-brand-ink text-white py-16 md:py-24 relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-brand-gold/10 rounded-full blur-3xl" />
            <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-brand-gold/10 rounded-full blur-3xl" />
            <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="text-[11px] uppercase tracking-[0.3em] font-bold text-brand-gold mb-3">Newsletter</div>
                <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                    Receba novidades em primeira mão
                </h2>
                <p className="mt-4 text-white/70 text-base sm:text-lg max-w-lg mx-auto">
                    Lançamentos, ofertas exclusivas e itens limitados direto no seu WhatsApp.
                </p>

                {done ? (
                    <div className="mt-10 inline-flex items-center gap-3 bg-brand-success/15 border border-brand-success/30 px-6 py-4 rounded-sm" data-testid="lead-done">
                        <CheckCircle2 className="w-5 h-5 text-brand-success" />
                        <span className="text-sm font-semibold">Cadastro recebido. Em breve falamos com você!</span>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-2xl mx-auto" data-testid="lead-form">
                        <input
                            required
                            data-testid="lead-name"
                            placeholder="Seu nome *"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            className="bg-white/10 border border-white/20 focus:border-brand-gold outline-none text-white placeholder-white/50 px-4 py-3.5 text-sm rounded-sm"
                        />
                        <input
                            required
                            data-testid="lead-whatsapp"
                            placeholder="WhatsApp *"
                            value={form.whatsapp}
                            onChange={(e) => setForm({ ...form, whatsapp: e.target.value })}
                            className="bg-white/10 border border-white/20 focus:border-brand-gold outline-none text-white placeholder-white/50 px-4 py-3.5 text-sm rounded-sm"
                        />
                        <input
                            type="email"
                            data-testid="lead-email"
                            placeholder="Email (opcional)"
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="bg-white/10 border border-white/20 focus:border-brand-gold outline-none text-white placeholder-white/50 px-4 py-3.5 text-sm rounded-sm"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="lead-submit"
                            className="sm:col-span-3 inline-flex items-center justify-center gap-2 bg-brand-gold text-white hover:bg-brand-goldHover transition-colors px-7 py-4 font-heading font-semibold rounded-sm disabled:opacity-60"
                        >
                            <Send className="w-4 h-4" /> {loading ? "Enviando…" : "Quero receber novidades"}
                        </button>
                    </form>
                )}
                <p className="mt-4 text-[11px] text-white/40">Seus dados ficam protegidos e jamais serão compartilhados.</p>
            </div>
        </section>
    );
};

export default LeadSignup;
